var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-form',{ref:"RkmForm"},[_c('rkm-row',[_c('rkm-col',[_c('rkm-form-textarea',{attrs:{"label":"Motivo da Evasão","validations":_vm.validations.motivoEvasao},model:{value:(_vm.model.motivoEvasao),callback:function ($$v) {_vm.$set(_vm.model, "motivoEvasao", $$v)},expression:"model.motivoEvasao"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }